module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-46.20990753.png";